var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0BB783",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7325 13.4307L13.0332 14.7803L20.2314 18.3793L27.4296 14.7803L24.7303 13.4307",
    stroke: "#0BB783",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0332 18.3799L20.2314 21.9789L27.4296 18.3799",
    stroke: "#0BB783",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2314 14.7807V8.48242",
    stroke: "#0BB783",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5322 11.1817L20.2316 8.48242L22.9309 11.1817",
    stroke: "#0BB783",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.471 26.0097L13.7454 23.7354L17.7256 25.4411L17.157 27.7154C19.0007 28.3412 20.9993 28.3412 22.843 27.7154L22.2744 25.4411L26.2546 23.7354L28.529 26.0097C28.8306 26.3113 29 26.7203 29 27.1469C29 27.5734 28.8306 27.9824 28.529 28.284C26.1762 30.3671 23.1424 31.5172 20 31.5172C16.8576 31.5172 13.8238 30.3671 11.471 28.284C11.1694 27.9824 11 27.5734 11 27.1469C11 26.7203 11.1694 26.3113 11.471 26.0097Z",
    stroke: "#0BB783",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIcon);
export default __webpack_public_path__ + "static/media/flow-icon.4b46048a4acfc0e70f784b86f2eaae0d.svg";
export { ForwardRef as ReactComponent };